import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { api, formatApiError } from "../lib/api";
import { tr, LANG } from "../lib/i18n";
import { useBranches, branchName } from "../lib/branches";

// Instant transfer of a car to another branch; who, when, from, to and the note go into the car's history.
export const TransferDialog = ({ vehicle, onClose, onDone }) => {
  const { branches } = useBranches();
  const others = branches.filter((b) => b.id !== vehicle.branch_id);
  const [to, setTo] = useState(others[0]?.id || "");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      await api.post(`/vehicles/${vehicle.id}/transfer`, { to_branch_id: to, note: note || null });
      toast.success(tr("br.transferred"));
      onDone();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="transfer-dialog">
        <DialogHeader className="pe-8"><DialogTitle>{tr("br.transfer_title", { p0: vehicle.stock_number })}</DialogTitle></DialogHeader>
        <label className="text-sm font-medium">{tr("br.to_branch")}
          <select className="mt-1 w-full h-10 border border-[var(--divider)] px-3" value={to} onChange={(e) => setTo(e.target.value)} data-testid="transfer-to">
            {others.map((b) => <option key={b.id} value={b.id}>{branchName(b, LANG)}</option>)}
          </select>
        </label>
        <label className="text-sm font-medium">{tr("br.note")}
          <textarea className="mt-1 w-full border border-[var(--divider)] p-2" rows={3} value={note} onChange={(e) => setNote(e.target.value)} data-testid="transfer-note" />
        </label>
        <div className="flex justify-end gap-2">
          <button className="btn-secondary" onClick={onClose} data-testid="transfer-cancel">{tr("x.cancel")}</button>
          <button className="btn-primary" disabled={!to || busy} onClick={go} data-testid="transfer-confirm">{tr("br.transfer")}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
